import { render } from "./wealth.vue?vue&type=template&id=6ecba769&scoped=true"
import script from "./wealth.vue?vue&type=script&lang=js"
export * from "./wealth.vue?vue&type=script&lang=js"

import "./wealth.vue?vue&type=style&index=0&id=6ecba769&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ecba769"]])

export default __exports__